module.exports = __webpack_public_path__ + "img/bq-bo.5a2b17ae.svg";